import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminOrganizations: build.query<
      GetV2AdminOrganizationsApiResponse,
      GetV2AdminOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations`,
        params: {
          search: queryArg.search,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationId: build.query<
      GetV2AdminOrganizationsByOrganizationIdApiResponse,
      GetV2AdminOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}`,
      }),
    }),
    patchV2AdminOrganizationsByOrganizationId: build.mutation<
      PatchV2AdminOrganizationsByOrganizationIdApiResponse,
      PatchV2AdminOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}`,
        method: "PATCH",
        body: queryArg.adminUpdateOrganizationRequest,
      }),
    }),
    putV2AdminOrganizationsByOrganizationIdBaa: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdBaaApiResponse,
      PutV2AdminOrganizationsByOrganizationIdBaaApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/baa`,
        method: "PUT",
        body: queryArg.adminUpdateStatusRequest,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdCancelSubscription: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdCancelSubscriptionApiResponse,
      PostV2AdminOrganizationsByOrganizationIdCancelSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/cancel-subscription`,
        method: "POST",
        body: queryArg.adminCancelSubscriptionRequest,
      }),
    }),
    putV2AdminOrganizationsByOrganizationIdCoi: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdCoiApiResponse,
      PutV2AdminOrganizationsByOrganizationIdCoiApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/coi`,
        method: "PUT",
        body: queryArg.adminUpdateStatusRequest,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdCreateSubscription: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiResponse,
      PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/create-subscription`,
        method: "POST",
        body: queryArg.createSubscriptionRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdCredits: build.query<
      GetV2AdminOrganizationsByOrganizationIdCreditsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdCreditsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/credits`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdCredits: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdCreditsApiResponse,
      PostV2AdminOrganizationsByOrganizationIdCreditsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/credits`,
        method: "POST",
        body: queryArg.adminApplyCreditRequest,
      }),
    }),
    putV2AdminOrganizationsByOrganizationIdDataRetention: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdDataRetentionApiResponse,
      PutV2AdminOrganizationsByOrganizationIdDataRetentionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/data-retention`,
        method: "PUT",
        body: queryArg.adminUpdateStatusRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdDataSecurity: build.query<
      GetV2AdminOrganizationsByOrganizationIdDataSecurityApiResponse,
      GetV2AdminOrganizationsByOrganizationIdDataSecurityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/data-security`,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdDiscounts: build.mutation<
      DeleteV2AdminOrganizationsByOrganizationIdDiscountsApiResponse,
      DeleteV2AdminOrganizationsByOrganizationIdDiscountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/discounts`,
        method: "DELETE",
        params: {
          subscription_item_id: queryArg.subscriptionItemId,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdDiscounts: build.query<
      GetV2AdminOrganizationsByOrganizationIdDiscountsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdDiscountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/discounts`,
      }),
    }),
    patchV2AdminOrganizationsByOrganizationIdDiscounts: build.mutation<
      PatchV2AdminOrganizationsByOrganizationIdDiscountsApiResponse,
      PatchV2AdminOrganizationsByOrganizationIdDiscountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/discounts`,
        method: "PATCH",
        body: queryArg.adminEditDiscountRequest,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdDiscounts: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdDiscountsApiResponse,
      PostV2AdminOrganizationsByOrganizationIdDiscountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/discounts`,
        method: "POST",
        body: queryArg.adminApplyDiscountRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdDocuments: build.query<
      GetV2AdminOrganizationsByOrganizationIdDocumentsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.pathOrganizationId}/documents`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          document_type: queryArg.documentType,
          organization_id: queryArg.queryOrganizationId,
          patient_id: queryArg.patientId,
          include_deleted: queryArg.includeDeleted,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdExtendTrial: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdExtendTrialApiResponse,
      PostV2AdminOrganizationsByOrganizationIdExtendTrialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/extend-trial`,
        method: "POST",
        body: queryArg.extendTrialRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdForms: build.query<
      GetV2AdminOrganizationsByOrganizationIdFormsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/forms`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdForms: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdFormsApiResponse,
      PostV2AdminOrganizationsByOrganizationIdFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/forms`,
        method: "POST",
        body: queryArg.adminFormCreateRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdFormsAndFormId: build.mutation<
      DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiResponse,
      DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/forms/${queryArg.formId}`,
        method: "DELETE",
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdInvitations: build.query<
      GetV2AdminOrganizationsByOrganizationIdInvitationsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdInvitationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/invitations`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          status: queryArg.status,
          email: queryArg.email,
          include_expired: queryArg.includeExpired,
        },
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdInvitations: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdInvitationsApiResponse,
      PostV2AdminOrganizationsByOrganizationIdInvitationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/invitations`,
        method: "POST",
        body: queryArg.adminSendInvitationRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationId:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/invitations/${queryArg.invitationId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationId:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiResponse,
        GetV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/invitations/${queryArg.invitationId}`,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResend:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResendApiResponse,
        PostV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResendApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/invitations/${queryArg.invitationId}/resend`,
          method: "POST",
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdInvoices: build.query<
      GetV2AdminOrganizationsByOrganizationIdInvoicesApiResponse,
      GetV2AdminOrganizationsByOrganizationIdInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/invoices`,
        params: {
          limit: queryArg.limit,
          starting_after: queryArg.startingAfter,
        },
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdMembers: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdMembersApiResponse,
      PostV2AdminOrganizationsByOrganizationIdMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/members`,
        method: "POST",
        body: queryArg.addMemberRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdMembersAndUserId: build.mutation<
      DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiResponse,
      DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}`,
        method: "DELETE",
        params: {
          role: queryArg.role,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfo:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse,
        GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/membership-info`,
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfo:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/membership-info`,
          method: "PATCH",
          body: queryArg.updateMembershipInfoRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivate:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiResponse,
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/reactivate`,
          method: "POST",
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRoles:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/roles`,
          method: "PATCH",
          body: queryArg.updateUserRolesRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMembersAndUserIdRoles:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse,
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/roles`,
          method: "POST",
          body: queryArg.addUserRoleRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMerge: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdMergeApiResponse,
      PostV2AdminOrganizationsByOrganizationIdMergeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/merge`,
        method: "POST",
        body: queryArg.mergeOrganizationsRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdPatientVisibility: build.query<
      GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse,
      GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/patient-visibility`,
      }),
    }),
    patchV2AdminOrganizationsByOrganizationIdPatientVisibility: build.mutation<
      PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse,
      PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/patient-visibility`,
        method: "PATCH",
        body: queryArg.updatePatientVisibilityRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdPermissions: build.query<
      GetV2AdminOrganizationsByOrganizationIdPermissionsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/permissions`,
      }),
    }),
    patchV2AdminOrganizationsByOrganizationIdPermissions: build.mutation<
      PatchV2AdminOrganizationsByOrganizationIdPermissionsApiResponse,
      PatchV2AdminOrganizationsByOrganizationIdPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/permissions`,
        method: "PATCH",
        body: queryArg.adminUpdatePermissionsMatrixRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdProviders: build.query<
      GetV2AdminOrganizationsByOrganizationIdProvidersApiResponse,
      GetV2AdminOrganizationsByOrganizationIdProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/providers`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdReactivateSubscription:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdReactivateSubscriptionApiResponse,
        PostV2AdminOrganizationsByOrganizationIdReactivateSubscriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/reactivate-subscription`,
          method: "POST",
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdRefunds: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdRefundsApiResponse,
      PostV2AdminOrganizationsByOrganizationIdRefundsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/refunds`,
        method: "POST",
        body: queryArg.adminRefundRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrl:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiResponse,
        GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/subscription-dashboard-url`,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdSyncSubscription: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiResponse,
      PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/sync-subscription`,
        method: "POST",
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdTemplates: build.query<
      GetV2AdminOrganizationsByOrganizationIdTemplatesApiResponse,
      GetV2AdminOrganizationsByOrganizationIdTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/templates`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdTemplates: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdTemplatesApiResponse,
      PostV2AdminOrganizationsByOrganizationIdTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/templates`,
        method: "POST",
        body: queryArg.adminTemplateCreateRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateId:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/templates/${queryArg.templateId}`,
          method: "DELETE",
        }),
      }),
    putV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateId:
      build.mutation<
        PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse,
        PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/templates/${queryArg.templateId}`,
          method: "PUT",
          body: queryArg.adminTemplateUpdateRequest,
        }),
      }),
    getV2AdminRoles: build.query<
      GetV2AdminRolesApiResponse,
      GetV2AdminRolesApiArg
    >({
      query: () => ({ url: `/v2/admin/roles` }),
    }),
    getV2ProviderOrganizations: build.query<
      GetV2ProviderOrganizationsApiResponse,
      GetV2ProviderOrganizationsApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations` }),
    }),
    patchV2ProviderOrganizations: build.mutation<
      PatchV2ProviderOrganizationsApiResponse,
      PatchV2ProviderOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations`,
        method: "PATCH",
        body: queryArg.updateOrganizationRequest,
      }),
    }),
    postV2ProviderOrganizationsBaa: build.mutation<
      PostV2ProviderOrganizationsBaaApiResponse,
      PostV2ProviderOrganizationsBaaApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/baa`,
        method: "POST",
        body: queryArg.baaRequest,
      }),
    }),
    postV2ProviderOrganizationsBundles: build.mutation<
      PostV2ProviderOrganizationsBundlesApiResponse,
      PostV2ProviderOrganizationsBundlesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/bundles`,
        method: "POST",
        body: queryArg.adminAddBundleRequest,
      }),
    }),
    deleteV2ProviderOrganizationsBundlesByAssignmentId: build.mutation<
      DeleteV2ProviderOrganizationsBundlesByAssignmentIdApiResponse,
      DeleteV2ProviderOrganizationsBundlesByAssignmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/bundles/${queryArg.assignmentId}`,
        method: "DELETE",
      }),
    }),
    putV2ProviderOrganizationsBundlesByAssignmentId: build.mutation<
      PutV2ProviderOrganizationsBundlesByAssignmentIdApiResponse,
      PutV2ProviderOrganizationsBundlesByAssignmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/bundles/${queryArg.assignmentId}`,
        method: "PUT",
        body: queryArg.adminAddBundleRequest,
      }),
    }),
    postV2ProviderOrganizationsCoi: build.mutation<
      PostV2ProviderOrganizationsCoiApiResponse,
      PostV2ProviderOrganizationsCoiApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/coi`,
        method: "POST",
        body: queryArg.coiRequest,
      }),
    }),
    postV2ProviderOrganizationsDataRetention: build.mutation<
      PostV2ProviderOrganizationsDataRetentionApiResponse,
      PostV2ProviderOrganizationsDataRetentionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/data-retention`,
        method: "POST",
        body: queryArg.dataRetentionRequest,
      }),
    }),
    getV2ProviderOrganizationsDataSecurity: build.query<
      GetV2ProviderOrganizationsDataSecurityApiResponse,
      GetV2ProviderOrganizationsDataSecurityApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/data-security` }),
    }),
    getV2ProviderOrganizationsForms: build.query<
      GetV2ProviderOrganizationsFormsApiResponse,
      GetV2ProviderOrganizationsFormsApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/forms` }),
    }),
    postV2ProviderOrganizationsForms: build.mutation<
      PostV2ProviderOrganizationsFormsApiResponse,
      PostV2ProviderOrganizationsFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/forms`,
        method: "POST",
        body: queryArg.providerFormCreateRequest,
      }),
    }),
    deleteV2ProviderOrganizationsFormsByFormId: build.mutation<
      DeleteV2ProviderOrganizationsFormsByFormIdApiResponse,
      DeleteV2ProviderOrganizationsFormsByFormIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/forms/${queryArg.formId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderOrganizationsInvitations: build.query<
      GetV2ProviderOrganizationsInvitationsApiResponse,
      GetV2ProviderOrganizationsInvitationsApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/invitations` }),
    }),
    postV2ProviderOrganizationsInvitations: build.mutation<
      PostV2ProviderOrganizationsInvitationsApiResponse,
      PostV2ProviderOrganizationsInvitationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations`,
        method: "POST",
        body: queryArg.providerInvitationRequest,
      }),
    }),
    postV2ProviderOrganizationsInvitationsAccept: build.mutation<
      PostV2ProviderOrganizationsInvitationsAcceptApiResponse,
      PostV2ProviderOrganizationsInvitationsAcceptApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/accept`,
        method: "POST",
        body: queryArg.providerInvitationAcceptRequest,
      }),
    }),
    getV2ProviderOrganizationsInvitationsValidateByToken: build.query<
      GetV2ProviderOrganizationsInvitationsValidateByTokenApiResponse,
      GetV2ProviderOrganizationsInvitationsValidateByTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/validate/${queryArg.token}`,
      }),
    }),
    deleteV2ProviderOrganizationsInvitationsByInvitationId: build.mutation<
      DeleteV2ProviderOrganizationsInvitationsByInvitationIdApiResponse,
      DeleteV2ProviderOrganizationsInvitationsByInvitationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/${queryArg.invitationId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderOrganizationsInvitationsByInvitationId: build.mutation<
      PatchV2ProviderOrganizationsInvitationsByInvitationIdApiResponse,
      PatchV2ProviderOrganizationsInvitationsByInvitationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/${queryArg.invitationId}`,
        method: "PATCH",
        body: queryArg.providerUpdateInvitationRequest,
      }),
    }),
    postV2ProviderOrganizationsInvitationsByInvitationIdResend: build.mutation<
      PostV2ProviderOrganizationsInvitationsByInvitationIdResendApiResponse,
      PostV2ProviderOrganizationsInvitationsByInvitationIdResendApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/${queryArg.invitationId}/resend`,
        method: "POST",
      }),
    }),
    getV2ProviderOrganizationsMembers: build.query<
      GetV2ProviderOrganizationsMembersApiResponse,
      GetV2ProviderOrganizationsMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members`,
        params: {
          role: queryArg.role,
        },
      }),
    }),
    deleteV2ProviderOrganizationsMembersByUserId: build.mutation<
      DeleteV2ProviderOrganizationsMembersByUserIdApiResponse,
      DeleteV2ProviderOrganizationsMembersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderOrganizationsMembersByUserIdBillingInfo: build.mutation<
      PatchV2ProviderOrganizationsMembersByUserIdBillingInfoApiResponse,
      PatchV2ProviderOrganizationsMembersByUserIdBillingInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/billing-info`,
        method: "PATCH",
        body: queryArg.updateMemberBillingInfoRequest,
      }),
    }),
    postV2ProviderOrganizationsMembersByUserIdBundles: build.mutation<
      PostV2ProviderOrganizationsMembersByUserIdBundlesApiResponse,
      PostV2ProviderOrganizationsMembersByUserIdBundlesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/bundles`,
        method: "POST",
        body: queryArg.adminAddBundleRequest,
      }),
    }),
    deleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentId:
      build.mutation<
        DeleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiResponse,
        DeleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/members/${queryArg.userId}/bundles/${queryArg.assignmentId}`,
          method: "DELETE",
        }),
      }),
    putV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentId:
      build.mutation<
        PutV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiResponse,
        PutV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/members/${queryArg.userId}/bundles/${queryArg.assignmentId}`,
          method: "PUT",
          body: queryArg.adminAddBundleRequest,
        }),
      }),
    getV2ProviderOrganizationsMembersByUserIdDetail: build.query<
      GetV2ProviderOrganizationsMembersByUserIdDetailApiResponse,
      GetV2ProviderOrganizationsMembersByUserIdDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/detail`,
      }),
    }),
    getV2ProviderOrganizationsMembersByUserIdMembershipInfo: build.query<
      GetV2ProviderOrganizationsMembersByUserIdMembershipInfoApiResponse,
      GetV2ProviderOrganizationsMembersByUserIdMembershipInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/membership-info`,
      }),
    }),
    patchV2ProviderOrganizationsMembersByUserIdMembershipInfo: build.mutation<
      PatchV2ProviderOrganizationsMembersByUserIdMembershipInfoApiResponse,
      PatchV2ProviderOrganizationsMembersByUserIdMembershipInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/membership-info`,
        method: "PATCH",
        body: queryArg.updateMembershipInfoRequest,
      }),
    }),
    patchV2ProviderOrganizationsMembersByUserIdProfile: build.mutation<
      PatchV2ProviderOrganizationsMembersByUserIdProfileApiResponse,
      PatchV2ProviderOrganizationsMembersByUserIdProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/profile`,
        method: "PATCH",
        body: queryArg.updateMemberProfileRequest,
      }),
    }),
    patchV2ProviderOrganizationsMembersByUserIdRoles: build.mutation<
      PatchV2ProviderOrganizationsMembersByUserIdRolesApiResponse,
      PatchV2ProviderOrganizationsMembersByUserIdRolesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/roles`,
        method: "PATCH",
        body: queryArg.providerUpdateRolesRequest,
      }),
    }),
    getV2ProviderOrganizationsPatientVisibility: build.query<
      GetV2ProviderOrganizationsPatientVisibilityApiResponse,
      GetV2ProviderOrganizationsPatientVisibilityApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/patient-visibility` }),
    }),
    patchV2ProviderOrganizationsPatientVisibility: build.mutation<
      PatchV2ProviderOrganizationsPatientVisibilityApiResponse,
      PatchV2ProviderOrganizationsPatientVisibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/patient-visibility`,
        method: "PATCH",
        body: queryArg.providerUpdatePatientVisibilityRequest,
      }),
    }),
    getV2ProviderOrganizationsPermissions: build.query<
      GetV2ProviderOrganizationsPermissionsApiResponse,
      GetV2ProviderOrganizationsPermissionsApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/permissions` }),
    }),
    patchV2ProviderOrganizationsPermissions: build.mutation<
      PatchV2ProviderOrganizationsPermissionsApiResponse,
      PatchV2ProviderOrganizationsPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/permissions`,
        method: "PATCH",
        body: queryArg.providerUpdatePermissionsMatrixRequest,
      }),
    }),
    patchV2ProviderOrganizationsPreferences: build.mutation<
      PatchV2ProviderOrganizationsPreferencesApiResponse,
      PatchV2ProviderOrganizationsPreferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/preferences`,
        method: "PATCH",
        body: queryArg.updateOrganizationPreferencesRequest,
      }),
    }),
    getV2ProviderOrganizationsRoles: build.query<
      GetV2ProviderOrganizationsRolesApiResponse,
      GetV2ProviderOrganizationsRolesApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/roles` }),
    }),
    getV2ProviderOrganizationsTemplates: build.query<
      GetV2ProviderOrganizationsTemplatesApiResponse,
      GetV2ProviderOrganizationsTemplatesApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/templates` }),
    }),
    postV2ProviderOrganizationsTemplates: build.mutation<
      PostV2ProviderOrganizationsTemplatesApiResponse,
      PostV2ProviderOrganizationsTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/templates`,
        method: "POST",
        body: queryArg.providerTemplateCreateRequest,
      }),
    }),
    deleteV2ProviderOrganizationsTemplatesByTemplateId: build.mutation<
      DeleteV2ProviderOrganizationsTemplatesByTemplateIdApiResponse,
      DeleteV2ProviderOrganizationsTemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/templates/${queryArg.templateId}`,
        method: "DELETE",
      }),
    }),
    putV2ProviderOrganizationsTemplatesByTemplateId: build.mutation<
      PutV2ProviderOrganizationsTemplatesByTemplateIdApiResponse,
      PutV2ProviderOrganizationsTemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/templates/${queryArg.templateId}`,
        method: "PUT",
        body: queryArg.providerTemplateUpdateRequest,
      }),
    }),
    postV2ProviderV2ProviderOrganizationsMembersByUserIdReactivate:
      build.mutation<
        PostV2ProviderV2ProviderOrganizationsMembersByUserIdReactivateApiResponse,
        PostV2ProviderV2ProviderOrganizationsMembersByUserIdReactivateApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/v2/provider/organizations/members/${queryArg.userId}/reactivate`,
          method: "POST",
        }),
      }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminOrganizationsApiResponse =
  /** status 200 OK */ ListResponseAdminOrganizationResponse;
export type GetV2AdminOrganizationsApiArg = {
  /** Search organizations by name, or paste a full Stripe subscription (sub_...) or customer (cus_...) ID for an exact match */
  search?: string | null;
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2AdminOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ AdminOrganizationDetailResponse;
export type GetV2AdminOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
};
export type PatchV2AdminOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ AdminUpdateOrganizationResponse;
export type PatchV2AdminOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
  adminUpdateOrganizationRequest: AdminUpdateOrganizationRequest;
};
export type PutV2AdminOrganizationsByOrganizationIdBaaApiResponse =
  /** status 200 OK */ AdminUpdateStatusResponse;
export type PutV2AdminOrganizationsByOrganizationIdBaaApiArg = {
  organizationId: string;
  adminUpdateStatusRequest: AdminUpdateStatusRequest;
};
export type PostV2AdminOrganizationsByOrganizationIdCancelSubscriptionApiResponse =
  /** status 200 OK */ AdminSubscriptionStateResponse;
export type PostV2AdminOrganizationsByOrganizationIdCancelSubscriptionApiArg = {
  organizationId: string;
  adminCancelSubscriptionRequest: AdminCancelSubscriptionRequest;
};
export type PutV2AdminOrganizationsByOrganizationIdCoiApiResponse =
  /** status 200 OK */ AdminUpdateStatusResponse;
export type PutV2AdminOrganizationsByOrganizationIdCoiApiArg = {
  organizationId: string;
  adminUpdateStatusRequest: AdminUpdateStatusRequest;
};
export type PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiResponse =
  /** status 200 OK */ CreateSubscriptionResponse;
export type PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiArg = {
  organizationId: string;
  createSubscriptionRequest: CreateSubscriptionRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdCreditsApiResponse =
  /** status 200 OK */ AdminOrganizationCreditsResponse;
export type GetV2AdminOrganizationsByOrganizationIdCreditsApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdCreditsApiResponse =
  /** status 200 OK */ AdminBillingActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdCreditsApiArg = {
  organizationId: string;
  adminApplyCreditRequest: AdminApplyCreditRequest;
};
export type PutV2AdminOrganizationsByOrganizationIdDataRetentionApiResponse =
  /** status 200 OK */ AdminUpdateStatusResponse;
export type PutV2AdminOrganizationsByOrganizationIdDataRetentionApiArg = {
  organizationId: string;
  adminUpdateStatusRequest: AdminUpdateStatusRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdDataSecurityApiResponse =
  /** status 200 OK */ CombinedDataSecurityStatusResponse;
export type GetV2AdminOrganizationsByOrganizationIdDataSecurityApiArg = {
  organizationId: string;
};
export type DeleteV2AdminOrganizationsByOrganizationIdDiscountsApiResponse =
  /** status 200 OK */ AdminBillingActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdDiscountsApiArg = {
  organizationId: string;
  /** Remove the discount from this line item instead of the subscription as a whole */
  subscriptionItemId?: string | null;
};
export type GetV2AdminOrganizationsByOrganizationIdDiscountsApiResponse =
  /** status 200 OK */ AdminOrganizationDiscountsResponse;
export type GetV2AdminOrganizationsByOrganizationIdDiscountsApiArg = {
  organizationId: string;
};
export type PatchV2AdminOrganizationsByOrganizationIdDiscountsApiResponse =
  /** status 200 OK */ AdminBillingActionResponse;
export type PatchV2AdminOrganizationsByOrganizationIdDiscountsApiArg = {
  organizationId: string;
  adminEditDiscountRequest: AdminEditDiscountRequest;
};
export type PostV2AdminOrganizationsByOrganizationIdDiscountsApiResponse =
  /** status 200 OK */ AdminBillingActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdDiscountsApiArg = {
  organizationId: string;
  adminApplyDiscountRequest: AdminApplyDiscountRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdDocumentsApiResponse =
  /** status 200 OK */ DocumentListResponse;
export type GetV2AdminOrganizationsByOrganizationIdDocumentsApiArg = {
  pathOrganizationId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by document type (e.g., 'lab_order', 'claim', 'form') */
  documentType?: string | null;
  /** Filter by organization ID */
  queryOrganizationId?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Whether to include soft-deleted documents */
  includeDeleted?: boolean;
  /** Start date for filtering (ISO 8601 format) */
  startDate?: string | null;
  /** End date for filtering (ISO 8601 format) */
  endDate?: string | null;
  /** Text search on filename and document title */
  search?: string | null;
  /** Field to sort by (created_at, updated_at, filename, size_bytes) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
};
export type PostV2AdminOrganizationsByOrganizationIdExtendTrialApiResponse =
  /** status 200 OK */ ExtendTrialResponse;
export type PostV2AdminOrganizationsByOrganizationIdExtendTrialApiArg = {
  organizationId: string;
  extendTrialRequest: ExtendTrialRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdFormsApiResponse =
  /** status 200 OK */ AdminFormListResponse;
export type GetV2AdminOrganizationsByOrganizationIdFormsApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdFormsApiResponse =
  /** status 200 OK */ AdminFormResponse2;
export type PostV2AdminOrganizationsByOrganizationIdFormsApiArg = {
  organizationId: string;
  adminFormCreateRequest: AdminFormCreateRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiResponse =
  /** status 200 OK */ ResourceActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiArg = {
  organizationId: string;
  formId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdInvitationsApiResponse =
  /** status 200 OK */ ListResponseAdminInvitationResponse;
export type GetV2AdminOrganizationsByOrganizationIdInvitationsApiArg = {
  organizationId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by status (pending, accepted, expired, cancelled) */
  status?: string | null;
  /** Filter by invited email address */
  email?: string | null;
  /** Include expired pending invitations */
  includeExpired?: boolean;
};
export type PostV2AdminOrganizationsByOrganizationIdInvitationsApiResponse =
  /** status 200 OK */ AdminInvitationResponse2;
export type PostV2AdminOrganizationsByOrganizationIdInvitationsApiArg = {
  organizationId: string;
  adminSendInvitationRequest: AdminSendInvitationRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiArg =
  {
    organizationId: string;
    invitationId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiResponse =
  /** status 200 OK */ AdminInvitationDetailResponse;
export type GetV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdApiArg =
  {
    organizationId: string;
    invitationId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResendApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdInvitationsAndInvitationIdResendApiArg =
  {
    organizationId: string;
    invitationId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdInvoicesApiResponse =
  /** status 200 OK */ AdminOrganizationInvoicesResponse;
export type GetV2AdminOrganizationsByOrganizationIdInvoicesApiArg = {
  organizationId: string;
  /** Number of invoices to return */
  limit?: number;
  /** Invoice ID to start after for pagination */
  startingAfter?: string | null;
};
export type PostV2AdminOrganizationsByOrganizationIdMembersApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdMembersApiArg = {
  organizationId: string;
  addMemberRequest: AddMemberRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiArg = {
  organizationId: string;
  userId: string;
  /** Specific role to remove (e.g., 'member', 'admin', 'clinician'). If not provided, removes all roles. */
  role?: string | null;
};
export type GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg =
  {
    organizationId: string;
    userId: string;
    updateMembershipInfoRequest: UpdateMembershipInfoRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse =
  /** status 200 OK */ RoleActionResponse;
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg =
  {
    organizationId: string;
    userId: string;
    updateUserRolesRequest: UpdateUserRolesRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse =
  /** status 200 OK */ RoleActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg =
  {
    organizationId: string;
    userId: string;
    addUserRoleRequest: AddUserRoleRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdMergeApiResponse =
  /** status 200 OK */ MergeOrganizationsResponse;
export type PostV2AdminOrganizationsByOrganizationIdMergeApiArg = {
  organizationId: string;
  mergeOrganizationsRequest: MergeOrganizationsRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse =
  /** status 200 OK */ PatientVisibilityResponse;
export type GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg = {
  organizationId: string;
};
export type PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse =
  /** status 200 OK */ PatientVisibilityResponse;
export type PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg = {
  organizationId: string;
  updatePatientVisibilityRequest: UpdatePatientVisibilityRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdPermissionsApiResponse =
  /** status 200 OK */ AdminPermissionsMatrixResponse;
export type GetV2AdminOrganizationsByOrganizationIdPermissionsApiArg = {
  organizationId: string;
};
export type PatchV2AdminOrganizationsByOrganizationIdPermissionsApiResponse =
  /** status 200 OK */ AdminPermissionsMatrixResponse;
export type PatchV2AdminOrganizationsByOrganizationIdPermissionsApiArg = {
  organizationId: string;
  adminUpdatePermissionsMatrixRequest: AdminUpdatePermissionsMatrixRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdProvidersApiResponse =
  /** status 200 OK */ ListResponseAdminProviderResponse;
export type GetV2AdminOrganizationsByOrganizationIdProvidersApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdReactivateSubscriptionApiResponse =
  /** status 200 OK */ AdminSubscriptionStateResponse;
export type PostV2AdminOrganizationsByOrganizationIdReactivateSubscriptionApiArg =
  {
    organizationId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdRefundsApiResponse =
  /** status 200 OK */ AdminRefundResponse;
export type PostV2AdminOrganizationsByOrganizationIdRefundsApiArg = {
  organizationId: string;
  adminRefundRequest: AdminRefundRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiResponse =
  /** status 200 OK */ SubscriptionDashboardUrlResponse;
export type GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiArg =
  {
    organizationId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiResponse =
  /** status 200 OK */ SyncSubscriptionResponse;
export type PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiArg = {
  organizationId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdTemplatesApiResponse =
  /** status 200 OK */ AdminTemplateListResponse;
export type GetV2AdminOrganizationsByOrganizationIdTemplatesApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdTemplatesApiResponse =
  /** status 200 OK */ AdminTemplateResponse2;
export type PostV2AdminOrganizationsByOrganizationIdTemplatesApiArg = {
  organizationId: string;
  adminTemplateCreateRequest: AdminTemplateCreateRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse =
  /** status 200 OK */ ResourceActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg =
  {
    organizationId: string;
    templateId: string;
  };
export type PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse =
  /** status 200 OK */ AdminTemplateResponse2;
export type PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg =
  {
    organizationId: string;
    templateId: string;
    adminTemplateUpdateRequest: AdminTemplateUpdateRequest;
  };
export type GetV2AdminRolesApiResponse =
  /** status 200 OK */ AvailableRolesResponse;
export type GetV2AdminRolesApiArg = void;
export type GetV2ProviderOrganizationsApiResponse =
  /** status 200 OK */ ProviderOrganizationResponse;
export type GetV2ProviderOrganizationsApiArg = void;
export type PatchV2ProviderOrganizationsApiResponse =
  /** status 200 OK */ UpdateOrganizationResponse;
export type PatchV2ProviderOrganizationsApiArg = {
  updateOrganizationRequest: UpdateOrganizationRequest;
};
export type PostV2ProviderOrganizationsBaaApiResponse =
  /** status 201 Created */ DataSecurityRequestResponse;
export type PostV2ProviderOrganizationsBaaApiArg = {
  baaRequest: BaaRequest;
};
export type PostV2ProviderOrganizationsBundlesApiResponse =
  /** status 201 Created */ AdminBundleActionResponse;
export type PostV2ProviderOrganizationsBundlesApiArg = {
  adminAddBundleRequest: AdminAddBundleRequest;
};
export type DeleteV2ProviderOrganizationsBundlesByAssignmentIdApiResponse =
  unknown;
export type DeleteV2ProviderOrganizationsBundlesByAssignmentIdApiArg = {
  assignmentId: string;
};
export type PutV2ProviderOrganizationsBundlesByAssignmentIdApiResponse =
  /** status 200 OK */ AdminBundleActionResponse;
export type PutV2ProviderOrganizationsBundlesByAssignmentIdApiArg = {
  assignmentId: string;
  adminAddBundleRequest: AdminAddBundleRequest;
};
export type PostV2ProviderOrganizationsCoiApiResponse =
  /** status 201 Created */ DataSecurityRequestResponse;
export type PostV2ProviderOrganizationsCoiApiArg = {
  coiRequest: CoiRequest;
};
export type PostV2ProviderOrganizationsDataRetentionApiResponse =
  /** status 201 Created */ DataSecurityRequestResponse;
export type PostV2ProviderOrganizationsDataRetentionApiArg = {
  dataRetentionRequest: DataRetentionRequest;
};
export type GetV2ProviderOrganizationsDataSecurityApiResponse =
  /** status 200 OK */ CombinedDataSecurityStatusResponse;
export type GetV2ProviderOrganizationsDataSecurityApiArg = void;
export type GetV2ProviderOrganizationsFormsApiResponse =
  /** status 200 OK */ ProviderFormListResponse;
export type GetV2ProviderOrganizationsFormsApiArg = void;
export type PostV2ProviderOrganizationsFormsApiResponse =
  /** status 200 OK */ ProviderFormResponse2;
export type PostV2ProviderOrganizationsFormsApiArg = {
  providerFormCreateRequest: ProviderFormCreateRequest;
};
export type DeleteV2ProviderOrganizationsFormsByFormIdApiResponse =
  /** status 200 OK */ ProviderResourceActionResponse;
export type DeleteV2ProviderOrganizationsFormsByFormIdApiArg = {
  formId: string;
};
export type GetV2ProviderOrganizationsInvitationsApiResponse =
  /** status 200 OK */ ProviderInvitationListResponse;
export type GetV2ProviderOrganizationsInvitationsApiArg = void;
export type PostV2ProviderOrganizationsInvitationsApiResponse =
  /** status 200 OK */ ProviderInvitationResponse2;
export type PostV2ProviderOrganizationsInvitationsApiArg = {
  providerInvitationRequest: ProviderInvitationRequest;
};
export type PostV2ProviderOrganizationsInvitationsAcceptApiResponse =
  /** status 200 OK */ ProviderInvitationAcceptResponse;
export type PostV2ProviderOrganizationsInvitationsAcceptApiArg = {
  providerInvitationAcceptRequest: ProviderInvitationAcceptRequest;
};
export type GetV2ProviderOrganizationsInvitationsValidateByTokenApiResponse =
  /** status 200 OK */ ProviderInvitationValidationResponse;
export type GetV2ProviderOrganizationsInvitationsValidateByTokenApiArg = {
  token: string;
};
export type DeleteV2ProviderOrganizationsInvitationsByInvitationIdApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type DeleteV2ProviderOrganizationsInvitationsByInvitationIdApiArg = {
  invitationId: string;
};
export type PatchV2ProviderOrganizationsInvitationsByInvitationIdApiResponse =
  /** status 200 OK */ ProviderInvitationResponse2;
export type PatchV2ProviderOrganizationsInvitationsByInvitationIdApiArg = {
  invitationId: string;
  providerUpdateInvitationRequest: ProviderUpdateInvitationRequest;
};
export type PostV2ProviderOrganizationsInvitationsByInvitationIdResendApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PostV2ProviderOrganizationsInvitationsByInvitationIdResendApiArg = {
  invitationId: string;
};
export type GetV2ProviderOrganizationsMembersApiResponse =
  /** status 200 OK */ ProviderMemberListResponse;
export type GetV2ProviderOrganizationsMembersApiArg = {
  /** Filter to members with this role (e.g., 'clinician', 'practice_administrator', 'supervisor') */
  role?: string | null;
};
export type DeleteV2ProviderOrganizationsMembersByUserIdApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type DeleteV2ProviderOrganizationsMembersByUserIdApiArg = {
  userId: string;
};
export type PatchV2ProviderOrganizationsMembersByUserIdBillingInfoApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PatchV2ProviderOrganizationsMembersByUserIdBillingInfoApiArg = {
  userId: string;
  updateMemberBillingInfoRequest: UpdateMemberBillingInfoRequest;
};
export type PostV2ProviderOrganizationsMembersByUserIdBundlesApiResponse =
  /** status 201 Created */ AdminBundleActionResponse;
export type PostV2ProviderOrganizationsMembersByUserIdBundlesApiArg = {
  userId: string;
  adminAddBundleRequest: AdminAddBundleRequest;
};
export type DeleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiResponse =
  unknown;
export type DeleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiArg =
  {
    userId: string;
    assignmentId: string;
  };
export type PutV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiResponse =
  /** status 200 OK */ AdminBundleActionResponse;
export type PutV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiArg =
  {
    userId: string;
    assignmentId: string;
    adminAddBundleRequest: AdminAddBundleRequest;
  };
export type GetV2ProviderOrganizationsMembersByUserIdDetailApiResponse =
  /** status 200 OK */ MemberDetailResponse;
export type GetV2ProviderOrganizationsMembersByUserIdDetailApiArg = {
  userId: string;
};
export type GetV2ProviderOrganizationsMembersByUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type GetV2ProviderOrganizationsMembersByUserIdMembershipInfoApiArg = {
  userId: string;
};
export type PatchV2ProviderOrganizationsMembersByUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type PatchV2ProviderOrganizationsMembersByUserIdMembershipInfoApiArg = {
  userId: string;
  updateMembershipInfoRequest: UpdateMembershipInfoRequest;
};
export type PatchV2ProviderOrganizationsMembersByUserIdProfileApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PatchV2ProviderOrganizationsMembersByUserIdProfileApiArg = {
  userId: string;
  updateMemberProfileRequest: UpdateMemberProfileRequest;
};
export type PatchV2ProviderOrganizationsMembersByUserIdRolesApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PatchV2ProviderOrganizationsMembersByUserIdRolesApiArg = {
  userId: string;
  providerUpdateRolesRequest: ProviderUpdateRolesRequest;
};
export type GetV2ProviderOrganizationsPatientVisibilityApiResponse =
  /** status 200 OK */ ProviderPatientVisibilityResponse;
export type GetV2ProviderOrganizationsPatientVisibilityApiArg = void;
export type PatchV2ProviderOrganizationsPatientVisibilityApiResponse =
  /** status 200 OK */ ProviderPatientVisibilityResponse;
export type PatchV2ProviderOrganizationsPatientVisibilityApiArg = {
  providerUpdatePatientVisibilityRequest: ProviderUpdatePatientVisibilityRequest;
};
export type GetV2ProviderOrganizationsPermissionsApiResponse =
  /** status 200 OK */ ProviderPermissionsMatrixResponse;
export type GetV2ProviderOrganizationsPermissionsApiArg = void;
export type PatchV2ProviderOrganizationsPermissionsApiResponse =
  /** status 200 OK */ ProviderPermissionsMatrixResponse;
export type PatchV2ProviderOrganizationsPermissionsApiArg = {
  providerUpdatePermissionsMatrixRequest: ProviderUpdatePermissionsMatrixRequest;
};
export type PatchV2ProviderOrganizationsPreferencesApiResponse =
  /** status 200 OK */ EffectiveOrganizationPreferences;
export type PatchV2ProviderOrganizationsPreferencesApiArg = {
  updateOrganizationPreferencesRequest: UpdateOrganizationPreferencesRequest;
};
export type GetV2ProviderOrganizationsRolesApiResponse =
  /** status 200 OK */ ProviderRoleListResponse;
export type GetV2ProviderOrganizationsRolesApiArg = void;
export type GetV2ProviderOrganizationsTemplatesApiResponse =
  /** status 200 OK */ ProviderTemplateListResponse;
export type GetV2ProviderOrganizationsTemplatesApiArg = void;
export type PostV2ProviderOrganizationsTemplatesApiResponse =
  /** status 200 OK */ ProviderTemplateResponse2;
export type PostV2ProviderOrganizationsTemplatesApiArg = {
  providerTemplateCreateRequest: ProviderTemplateCreateRequest;
};
export type DeleteV2ProviderOrganizationsTemplatesByTemplateIdApiResponse =
  /** status 200 OK */ ProviderResourceActionResponse;
export type DeleteV2ProviderOrganizationsTemplatesByTemplateIdApiArg = {
  templateId: string;
};
export type PutV2ProviderOrganizationsTemplatesByTemplateIdApiResponse =
  /** status 200 OK */ ProviderTemplateResponse2;
export type PutV2ProviderOrganizationsTemplatesByTemplateIdApiArg = {
  templateId: string;
  providerTemplateUpdateRequest: ProviderTemplateUpdateRequest;
};
export type PostV2ProviderV2ProviderOrganizationsMembersByUserIdReactivateApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PostV2ProviderV2ProviderOrganizationsMembersByUserIdReactivateApiArg =
  {
    userId: string;
  };
export type AdminOrganizationResponse = {
  /** Total number of admins */
  admin_count?: number;
  /** Billing admin user ID */
  billing_admin_id?: string | null;
  /** ISO timestamp of creation */
  created_at?: string | null;
  /** Total number of members */
  member_count?: number;
  /** Organization name */
  name: string;
  /** Unique organization identifier */
  organization_id: string;
  /** Stripe customer ID */
  stripe_customer_id?: string | null;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
};
export type ListResponseAdminOrganizationResponse = {
  items: AdminOrganizationResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type AdminOrganizationMemberResponse = {
  /** User email */
  email?: string | null;
  /** User name */
  name?: string | null;
  /** User's payment status */
  payment_status?: string | null;
  /** Role in organization */
  role: string;
  /** User ID */
  user_id: string;
  /** Full user info object */
  user_info?: {
    [key: string]: any;
  } | null;
  /** User's metrics data */
  user_metrics?: {
    [key: string]: any;
  } | null;
};
export type JotBillRoutingPayerResponse = {
  /** Payer logo URL */
  avatar_url?: string | null;
  /** Payer display name */
  display_name: string;
  /** Internal payer UUID */
  payer_uuid: string;
  /** Primary payer ID */
  primary_payer_id?: string | null;
  /** Stedi payer ID */
  stedi_id?: string | null;
};
export type JotBillRoutingConfigResponse = {
  /** Payer UUIDs that auto-enable bill-with-JotPsych */
  auto_enable_payer_uuids?: string[];
  /** Display data for payer UUIDs that auto-enable bill-with-JotPsych */
  auto_enable_payers?: JotBillRoutingPayerResponse[];
  /** Auto-enable bill-with-JotPsych for self-pay patients */
  auto_enable_self_pay?: boolean;
  /** Default routing mode: 'off' or 'all_on' */
  default_mode?: "off" | "all_on";
};
export type AdminOrganizationUserResponse = {
  /** ISO timestamp when user was deactivated (null if active) */
  deactivated_at?: string | null;
  /** User email */
  email?: string | null;
  /** Historical (record-only) member: exists only so records can attribute to this person; permanently inactive, cannot be reactivated, and cannot log in */
  is_historical?: boolean;
  /** User name */
  name?: string | null;
  /** User's payment status */
  payment_status?: string | null;
  /** List of roles in organization */
  roles?: string[];
  /** Membership status: 'active' or 'inactive' */
  status?: string;
  /** User ID */
  user_id: string;
  /** Full user info object */
  user_info?: {
    [key: string]: any;
  } | null;
  /** User's metrics data */
  user_metrics?: {
    [key: string]: any;
  } | null;
};
export type AdminOrganizationDetailResponse = {
  /** Billing admin details */
  billing_admin?: AdminOrganizationMemberResponse | null;
  /** ISO timestamp of creation */
  created_at?: string | null;
  /** DoseSpot clinic_id when the organization is connected. Null otherwise. */
  dosespot_clinic_id?: string | null;
  /** True when the organization has both a DoseSpot clinic_id and clinic_key configured. Use this to gate DoseSpot-dependent UI without probing the API. */
  dosespot_connected?: boolean;
  /** Full organization metadata */
  group_info?: {
    [key: string]: any;
  };
  /** Bill-with-JotPsych routing configuration */
  jotbill_routing_config?: JotBillRoutingConfigResponse | null;
  /** Organization name */
  name: string;
  /** Unique organization identifier */
  organization_id: string;
  /** Stripe customer ID */
  stripe_customer_id?: string | null;
  /** Stripe subscription status from webhook (stored in stripe_info) */
  stripe_status_from_webhook?: string | null;
  /** Full Stripe subscription details including status, billing period, and payment info */
  stripe_subscription_details?: {
    [key: string]: any;
  } | null;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Number of seats/users in the subscription */
  stripe_subscription_quantity?: number | null;
  /** All organization users with their roles and status (including inactive) */
  users?: AdminOrganizationUserResponse[];
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type AdminUpdateOrganizationResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID that was updated */
  organization_id: string;
  /** Whether the update was successful */
  success: boolean;
  /** Fields that were updated with their new values */
  updated_fields?: {
    [key: string]: any;
  };
};
export type JotBillRoutingConfigRequest = {
  /** Payer UUIDs that auto-enable bill-with-JotPsych */
  auto_enable_payer_uuids?: string[];
  /** Auto-enable bill-with-JotPsych for self-pay patients */
  auto_enable_self_pay?: boolean;
  /** Default routing mode: 'off' or 'all_on' */
  default_mode?: "off" | "all_on";
};
export type AdminUpdateOrganizationRequest = {
  /** Bill-with-JotPsych routing configuration */
  jotbill_routing_config?: JotBillRoutingConfigRequest | null;
  /** New organization name */
  name?: string | null;
};
export type AdminUpdateStatusResponse = {
  /** User-friendly message */
  message: string;
  /** Status after update */
  new_status: string;
  /** Organization ID */
  organization_id: string;
  /** Status before update */
  previous_status: string;
  /** Service updated: 'baa', 'coi', or 'retention' */
  service: string;
  /** Whether the update succeeded */
  success: boolean;
  /** ISO 8601 timestamp */
  updated_at: string;
};
export type AdminUpdateStatusRequest = {
  /** Admin notes for audit trail */
  notes?: string | null;
  /** New status: 'not_configured', 'processing', or 'active' */
  status: string;
};
export type AdminSubscriptionStateResponse = {
  /** Whether the subscription is scheduled to cancel */
  cancel_at_period_end?: boolean | null;
  /** When the subscription was canceled (Unix timestamp) */
  canceled_at?: number | null;
  /** End of the current billing period (Unix timestamp) */
  current_period_end?: number | null;
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Current subscription status */
  status?: string | null;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Whether the action succeeded */
  success: boolean;
};
export type AdminCancelSubscriptionRequest = {
  /** When true (the default), the subscription stays active until the end of the current billing period, matching what a user gets when they cancel from the app. When false, the subscription is canceled immediately and access is revoked right away. */
  cancel_at_period_end?: boolean;
  /** Optional reason stored with the subscription in Stripe */
  cancellation_reason?: string | null;
};
export type CreateSubscriptionResponse = {
  /** Stripe customer ID */
  customer_id?: string | null;
  /** Error details if the operation failed */
  error?: string | null;
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Number of seats on the subscription */
  quantity?: number | null;
  /** Stripe subscription ID */
  subscription_id?: string | null;
  /** Whether the subscription was created */
  success: boolean;
  /** Number of trial days */
  trial_days?: number | null;
};
export type CreateSubscriptionRequest = {
  /** Number of trial days (0-365). Defaults to STRIPE_NUM_FREE_TRIAL_DAYS env var if not provided. */
  trial_days?: number | null;
};
export type AdminCreditBalanceTransaction = {
  /** Adjustment in cents using Stripe's sign convention: negative granted credit, positive billed the customer */
  amount: number;
  /** When the adjustment was made (Unix timestamp) */
  created?: number | null;
  /** Reason recorded when the adjustment was made */
  description?: string | null;
  /** Customer balance in cents after this adjustment, in Stripe's sign convention (negative means credit available) */
  ending_balance: number;
  /** Stripe balance transaction ID */
  id: string;
};
export type AdminOrganizationCreditsResponse = {
  /** Credit available in cents, sign-flipped from Stripe so a positive number means the organization has that much credit to draw on. Negative means the organization owes that amount */
  credit_balance?: number;
  /** False when the organization has no Stripe customer, in which case the balance is zero because there is nowhere to hold credit */
  has_stripe_customer?: boolean;
  /** Adjustment history, most recent first */
  transactions?: AdminCreditBalanceTransaction[];
};
export type AdminBillingActionResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Whether the action succeeded */
  success: boolean;
};
export type AdminApplyCreditRequest = {
  /** Credit to grant in cents, as a positive number. Use a negative number to claw credit back. This is the human-facing sign convention and is inverted before it reaches Stripe */
  amount: number;
  /** Why the credit was applied; recorded in Stripe and in our events */
  reason: string;
};
export type BaaStatusResponse = {
  /** ISO 8601 timestamp (if active) */
  activated_at?: string | null;
  /** Entity name from request */
  entity_name?: string | null;
  /** UUID if requested */
  request_id?: string | null;
  /** ISO 8601 timestamp */
  requested_at?: string | null;
  /** BAA status: 'not_entitled', 'not_configured', 'processing', 'active' */
  status: string;
};
export type CoiStatusResponse = {
  /** ISO 8601 timestamp (if active) */
  activated_at?: string | null;
  /** Business name from request */
  business_name?: string | null;
  /** UUID if requested */
  request_id?: string | null;
  /** ISO 8601 timestamp */
  requested_at?: string | null;
  /** COI status: 'not_entitled', 'not_configured', 'processing', 'active' */
  status: string;
};
export type DataRetentionStatusResponse = {
  /** ISO 8601 timestamp (if active) */
  activated_at?: string | null;
  /** ISO 8601 timestamp */
  configured_at?: string | null;
  /** UUID if configured */
  request_id?: string | null;
  /** Status: 'not_entitled', 'not_configured', 'processing', 'active' */
  status: string;
  /** Current setting */
  unsigned_notes_retention_days?: number | null;
};
export type CombinedDataSecurityStatusResponse = {
  /** BAA status */
  baa: BaaStatusResponse;
  /** Certificate of Insurance status */
  coi: CoiStatusResponse;
  /** Data retention policy status */
  data_retention: DataRetentionStatusResponse;
  /** Whether user has any data security capability */
  has_bundle: boolean;
};
export type AdminDiscountResponse = {
  /** Fixed discount in cents, when the coupon is amount-based */
  amount_off?: number | null;
  /** Stripe coupon ID */
  coupon_id?: string | null;
  /** Coupon display name */
  coupon_name?: string | null;
  /** How long the discount lasts (once, repeating, forever) */
  duration?: string | null;
  /** Number of months, when duration is repeating */
  duration_in_months?: number | null;
  /** When the discount expires (Unix timestamp), null if forever */
  end?: number | null;
  /** Stripe discount ID */
  id?: string | null;
  /** Whether staff applied this from the admin panel. Only these are editable or removable by hand: referral coupons use shared IDs across many organizations, and bundle intro offers carry eligibility accounting */
  is_admin_applied?: boolean;
  /** Percentage discount, when the coupon is percentage-based */
  percent_off?: number | null;
  /** Why staff applied it, from coupon metadata. INTERNAL — absent on automatic and legacy coupons */
  reason?: string | null;
  /** When the discount took effect (Unix timestamp) */
  start?: number | null;
};
export type AdminItemDiscountResponse = {
  /** Fixed discount in cents, when the coupon is amount-based */
  amount_off?: number | null;
  /** Stripe coupon ID */
  coupon_id?: string | null;
  /** Coupon display name */
  coupon_name?: string | null;
  /** How long the discount lasts (once, repeating, forever) */
  duration?: string | null;
  /** Number of months, when duration is repeating */
  duration_in_months?: number | null;
  /** When the discount expires (Unix timestamp), null if forever */
  end?: number | null;
  /** Stripe discount ID */
  id?: string | null;
  /** Whether staff applied this from the admin panel. Only these are editable or removable by hand: referral coupons use shared IDs across many organizations, and bundle intro offers carry eligibility accounting */
  is_admin_applied?: boolean;
  /** Percentage discount, when the coupon is percentage-based */
  percent_off?: number | null;
  /** Product the item bills for, for display */
  product_name?: string | null;
  /** Why staff applied it, from coupon metadata. INTERNAL — absent on automatic and legacy coupons */
  reason?: string | null;
  /** When the discount took effect (Unix timestamp) */
  start?: number | null;
  /** Subscription item the discount is scoped to */
  subscription_item_id?: string | null;
};
export type AdminSubscriptionLineItem = {
  /** Whether this line already carries a discount */
  has_discount?: boolean;
  /** Product being billed */
  product_name?: string | null;
  /** Seats or units on this line */
  quantity?: number | null;
  /** Stripe subscription item ID */
  subscription_item_id: string;
  /** Price per unit in cents, before discounts */
  unit_amount?: number | null;
};
export type AdminOrganizationDiscountsResponse = {
  /** Subscription-level discounts. At most one in practice — Stripe replaces rather than stacks at this level */
  discounts?: AdminDiscountResponse[];
  /** Discounts scoped to individual subscription items. These do not displace the subscription-level discount or each other */
  item_discounts?: AdminItemDiscountResponse[];
  /** Billable lines, so a discount can be targeted at one */
  line_items?: AdminSubscriptionLineItem[];
};
export type AdminEditDiscountRequest = {
  /** New customer-facing name, shown on their Stripe invoice */
  customer_label?: string | null;
  /** New internal reason. Never shown to the customer */
  reason?: string | null;
  /** Edit the discount on this line item rather than the subscription */
  subscription_item_id?: string | null;
};
export type AdminApplyDiscountRequest = {
  /** Fixed discount in cents */
  amount_off?: number | null;
  /** What the customer sees next to the deduction on their Stripe invoice. Stripe caps this at 40 characters. Defaults to a plain 'Discount' so an internal note never leaks by accident */
  customer_label?: string;
  /** How long the discount should last */
  duration?: "once" | "repeating" | "forever";
  /** Months to repeat for; required when duration=repeating */
  duration_in_months?: number | null;
  /** Percentage discount (1-100) */
  percent_off?: number | null;
  /** Why the discount was applied. INTERNAL — stored in our events and in coupon metadata, and shown in the admin panel. Never put on the customer's invoice; use customer_label for that */
  reason: string;
  /** Must be true to apply a discount when one is already active at the same level. Applying over an existing discount replaces it, which would silently drop a referral coupon, so it requires explicit intent */
  replace_existing?: boolean;
  /** Apply to a single line item instead of the whole subscription. Item discounts do not displace the subscription-level one (or each other), so this is the safer way to give a targeted concession. Omit to discount the whole subscription */
  subscription_item_id?: string | null;
};
export type CommunicationChannelStatus = {
  /** Communication channel: 'sms' or 'email' */
  channel: string;
  /** When message was delivered */
  delivered_at?: string | null;
  /** Error details if delivery failed */
  error_message?: string | null;
  /** When delivery failed */
  failed_at?: string | null;
  /** When message was sent */
  sent_at?: string | null;
  /** Delivery status: queued, sent, delivered, failed, bounced, dropped, opened, clicked */
  status: string;
};
export type FormStatusInfo = {
  /** ID of the form session */
  form_session_id: string;
  /** Form status: pending, in_progress, or completed */
  status: string;
  /** When the form was submitted */
  submitted_at?: string | null;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  activity_status?: "active" | "inactive";
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  /** True if the patient has a phone or email a reminder could be delivered to. None when unknown (patient not fully loaded). */
  reminder_reachable?: boolean | null;
  telephone?: string | null;
};
export type DocumentSummaryResponse = {
  author_facility?: string | null;
  author_provider_name?: string | null;
  authored_at?: string | null;
  /** Per-channel delivery status if document was sent to patient */
  communication_status?: CommunicationChannelStatus[] | null;
  /** MIME type (e.g., 'application/pdf') */
  content_type: string;
  /** When document was created (ISO 8601 UTC) */
  created_at: string;
  description?: string | null;
  doc_kind?: string | null;
  /** Unique identifier for the document */
  document_id: string;
  /** User-set title for the document (legacy DocumentMetadata). For DocRef-backed rows, `title` carries the extraction-derived clinical title. */
  document_title?: string | null;
  /** Type of document (e.g., 'lab_order', 'form', 'document') */
  document_type?: string | null;
  effective_date?: string | null;
  encounter_id?: string | null;
  /** Original filename */
  filename: string;
  /** Form lifecycle status if document originated from a form submission */
  form_status?: FormStatusInfo | null;
  /** Patient information if patient_id is set */
  patient?: PatientInfo | null;
  /** Patient associated with the document */
  patient_id?: string | null;
  processing_status?: string | null;
  signed_at?: string | null;
  /** File size in bytes */
  size_bytes: number;
  /** Which storage layer backs this row. 'document_metadata' = legacy mongo (thin). 'document_reference' = GDN-914 DocRef with Fast Card enrichment. FE switches download / detail flows on this. */
  source?: string;
  source_artifact_id?: string | null;
  source_location?: {
    [key: string]: any;
  } | null;
  tags?: string[];
  title?: string | null;
};
export type DocumentListResponse = {
  items: DocumentSummaryResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ExtendTrialResponse = {
  /** Error details if the operation failed */
  error?: string | null;
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Current subscription status */
  subscription_status?: string | null;
  /** Whether the trial extension was successful */
  success: boolean;
  /** New trial end date in ISO format */
  trial_end?: string | null;
};
export type ExtendTrialRequest = {
  /** Number of days to extend the trial (1-365) */
  days: number;
};
export type AdminFormResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Form ID */
  form_id: string;
  /** Whether the form is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
};
export type AdminFormListResponse = {
  /** List of forms */
  forms?: AdminFormResponse[];
  /** Total number of forms */
  total_count?: number;
};
export type AdminFormResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Form ID */
  form_id: string;
  /** Whether the form is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
};
export type AdminFormCreateRequest = {
  /** Form ID to add */
  form_id: string;
};
export type ResourceActionResponse = {
  /** Error message if operation failed */
  error?: string | null;
  /** Response message */
  message?: string | null;
  /** ID of the affected resource */
  resource_id?: string | null;
  /** Whether the operation was successful */
  success: boolean;
};
export type AdminInvitationResponse = {
  /** When the invitation was accepted */
  accepted_at?: string | null;
  /** UUID of user who accepted */
  accepted_by_user_id?: string | null;
  /** When the invitation was created */
  created_at: string;
  /** When the invitation expires */
  expires_at: string;
  /** Invitation UUID */
  invitation_id: string;
  /** UUID of the user who sent the invitation */
  invited_by_user_id?: string | null;
  /** Invited email address */
  invited_email: string;
  /** Organization UUID */
  organization_id: string;
  /** Bundle IDs to assign when accepted */
  preset_bundles?: string[];
  /** Roles to assign when accepted */
  preset_roles?: string[] | null;
  /** Invitation status */
  status: string;
};
export type ListResponseAdminInvitationResponse = {
  items: AdminInvitationResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AdminInvitationResponse2 = {
  /** When the invitation was accepted */
  accepted_at?: string | null;
  /** UUID of user who accepted */
  accepted_by_user_id?: string | null;
  /** When the invitation was created */
  created_at: string;
  /** When the invitation expires */
  expires_at: string;
  /** Invitation UUID */
  invitation_id: string;
  /** UUID of the user who sent the invitation */
  invited_by_user_id?: string | null;
  /** Invited email address */
  invited_email: string;
  /** Organization UUID */
  organization_id: string;
  /** Bundle IDs to assign when accepted */
  preset_bundles?: string[];
  /** Roles to assign when accepted */
  preset_roles?: string[] | null;
  /** Invitation status */
  status: string;
};
export type AdminSendInvitationRequest = {
  /** Bundle IDs to assign on acceptance */
  bundle_ids?: string[] | null;
  /** Email address to invite */
  email: string;
  /** Roles to assign to the invited user */
  roles: string[];
};
export type MemberActionResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID that was modified */
  organization_id?: string | null;
  /** Whether the operation was successful */
  success: boolean;
  /** User ID that was affected */
  user_id?: string | null;
};
export type AdminInvitationDetailResponse = {
  /** When the invitation was accepted */
  accepted_at?: string | null;
  /** UUID of user who accepted */
  accepted_by_user_id?: string | null;
  /** When the invitation was created */
  created_at: string;
  /** When the invitation expires */
  expires_at: string;
  /** Invitation UUID */
  invitation_id: string;
  /** UUID of the user who sent the invitation */
  invited_by_user_id?: string | null;
  /** Invited email address */
  invited_email: string;
  /** Additional metadata */
  metadata?: {
    [key: string]: any;
  };
  /** Organization UUID */
  organization_id: string;
  /** Bundle IDs to assign when accepted */
  preset_bundles?: string[];
  /** Pre-assigned profile settings */
  preset_profile?: {
    [key: string]: any;
  };
  /** Roles to assign when accepted */
  preset_roles?: string[] | null;
  /** Invitation status */
  status: string;
};
export type SubscriptionInvoice = {
  /** Amount due in cents */
  amount_due: number;
  /** Amount paid in cents */
  amount_paid: number;
  /** Amount already refunded against this invoice's charge, in cents. Null means refund state was not loaded, which is distinct from zero (loaded, nothing refunded) */
  amount_refunded?: number | null;
  /** Amount remaining to be paid in cents */
  amount_remaining?: number;
  /** Amount actually collected by the charge, in cents. This is the refund ceiling and is NOT the invoice total: when customer credit is applied, the charge only covers the remainder */
  charge_amount?: number | null;
  /** Stripe charge backing this invoice, when one exists. Only populated on admin surfaces, which use it as the refund target */
  charge_id?: string | null;
  /** When the invoice was created */
  created: string;
  /** Due date if applicable */
  due_date?: string | null;
  /** URL to view invoice online */
  hosted_invoice_url?: string | null;
  /** Stripe invoice ID */
  id: string;
  /** URL to download invoice PDF */
  invoice_pdf?: string | null;
  /** Invoice number */
  number?: string | null;
  /** When the invoice was paid */
  paid_at?: string | null;
  /** Credit notes amount applied after payment in cents */
  post_payment_credit_notes_amount?: number;
  /** Credit notes amount applied before payment in cents */
  pre_payment_credit_notes_amount?: number;
  /** Invoice status (draft, open, paid, etc.) */
  status: string;
  /** Sum of all line items before discounts and taxes in cents */
  subtotal?: number;
  /** Total after discounts and taxes in cents (negative for credits) */
  total?: number;
};
export type AdminUpcomingInvoiceLineDiscount = {
  /** Amount taken off this line, in cents */
  amount: number;
  /** The coupon name — what appears on the customer's Stripe invoice */
  customer_label?: string | null;
  /** Why staff applied it. INTERNAL. Absent on automatic and legacy coupons, which predate the reason being stored on the coupon */
  reason?: string | null;
};
export type AdminUpcomingInvoiceLine = {
  /** Line amount in cents BEFORE discounts (negative for credits). Subtract `discounts` to get what this line contributes to the total */
  amount?: number;
  /** Line item description */
  description?: string | null;
  /** Discounts reducing this line, empty when undiscounted */
  discounts?: AdminUpcomingInvoiceLineDiscount[];
  /** End of the period this line covers (Unix timestamp) */
  period_end?: number | null;
  /** Start of the period this line covers (Unix timestamp) */
  period_start?: number | null;
  /** Whether this line is a mid-cycle proration adjustment */
  proration?: boolean;
  /** Quantity billed */
  quantity?: number | null;
};
export type AdminUpcomingInvoiceResponse = {
  /** Amount due in cents */
  amount_due: number;
  /** Customer balance credit consumed by this invoice, in cents, as a positive number. Drawn after discounts, which is why total and amount_due differ */
  credit_applied?: number;
  /** Three-letter currency code */
  currency?: string | null;
  /** Line items making up the upcoming invoice */
  lines?: AdminUpcomingInvoiceLine[];
  /** When Stripe will attempt payment (Unix timestamp) */
  next_payment_attempt?: number | null;
  /** End of the billing period (Unix timestamp) */
  period_end?: number | null;
  /** Start of the billing period (Unix timestamp) */
  period_start?: number | null;
  /** Discounts applied to the whole subscription rather than one line. Kept separate because nesting them under a line misrepresents what they apply to */
  subscription_discounts?: AdminUpcomingInvoiceLineDiscount[];
  /** Sum of line items before discounts in cents */
  subtotal?: number;
  /** Total after discounts and taxes in cents */
  total?: number;
  /** Total taken off by discounts in cents, both levels combined */
  total_discount_amount?: number;
};
export type AdminOrganizationInvoicesResponse = {
  /** Whether more invoices are available */
  has_more?: boolean;
  /** Past invoices, most recent first */
  invoices?: SubscriptionInvoice[];
  /** Use as starting_after for the next page */
  next_cursor?: string | null;
  /** Preview of the next invoice; null when the organization has no upcoming invoice (or when paginating past the first page) */
  upcoming?: AdminUpcomingInvoiceResponse | null;
};
export type AddMemberRequest = {
  /** Optional list of bundle IDs to assign to the user */
  bundle_ids?: string[] | null;
  /** Role to assign to the user (e.g., 'member', 'admin', 'clinician', 'operations_support', 'practice_administrator', 'supervisor') */
  role: string;
  /** User ID to add to the organization */
  user_id: string;
};
export type MembershipInfoResponse = {
  /** Current effective prepare-on-behalf capability status */
  can_prepare_prescriptions_on_behalf?: boolean;
  /** Human-readable message */
  message: string;
  /** Current co-sign requirement status */
  needs_cosign: boolean;
  /** Organization ID */
  organization_id: string;
  /** Whether the operation was successful */
  success: boolean;
  /** Currently assigned cosigning supervisor, if any */
  supervisor_user_id?: string | null;
  /** User ID */
  user_id: string;
};
export type UpdateMembershipInfoRequest = {
  /** Whether this member may prepare prescriptions on behalf of a prescriber (GDN-1119). Only granted to operations_support members. */
  can_prepare_prescriptions_on_behalf?: boolean | null;
  /** Whether this member's notes require co-signature from a supervisor */
  needs_cosign?: boolean | null;
  /** The supervisor responsible for co-signing this member's notes. Must hold the supervisor role in the organization. Pass an explicit null to clear the assignment (omitting the field preserves it); unassigned members who need co-signing are visible to all supervisors. */
  supervisor_user_id?: string | null;
};
export type RoleActionResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Current roles after the operation */
  roles?: string[];
  /** Whether the operation was successful */
  success: boolean;
  /** User ID that was affected */
  user_id: string;
};
export type UpdateUserRolesRequest = {
  /** Complete list of roles to assign to the user */
  roles: string[];
};
export type AddUserRoleRequest = {
  /** Role to add to the user (e.g., 'clinician', 'supervisor') */
  role: string;
};
export type MergeOrganizationsResponse = {
  /** Number of appointment series transferred */
  appointment_series_moved?: number;
  /** Number of appointments transferred */
  appointments_moved?: number;
  /** Number of encounter types transferred */
  encounter_types_moved?: number;
  /** Number of encounters transferred */
  encounters_moved?: number;
  /** Error details if the operation failed */
  error?: string | null;
  /** Number of memberships transferred */
  memberships_moved?: number;
  /** Human-readable message about the operation */
  message: string;
  /** Number of notes transferred */
  notes_moved?: number;
  /** Number of patients transferred */
  patients_moved?: number;
  /** Rows transferred to the target organization, keyed by resource type */
  resources_moved?: {
    [key: string]: number;
  };
  /** Whether the source organization was successfully deleted */
  source_deleted?: boolean;
  /** Organization that was merged and deleted */
  source_organization_id: string;
  /** User ID whose organization was merged (if provided in request) */
  source_user_id?: string | null;
  /** Whether the merge was successful */
  success: boolean;
  /** Organization that received the members */
  target_organization_id: string;
  /** Registered org-scoped resource types that were not re-tenanted during the merge */
  uncovered_resource_types?: string[];
};
export type MergeOrganizationsRequest = {
  /** Roles to assign to the merged user in the target organization (e.g., ['admin', 'member']) */
  roles?: string[] | null;
  /** Organization ID to merge FROM (will be deleted) */
  source_organization_id?: string | null;
  /** User ID whose organization should be merged FROM */
  source_user_id?: string | null;
};
export type PatientVisibilityResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Current patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
  /** Organization ID */
  organization_id: string;
  /** Whether the operation was successful */
  success: boolean;
};
export type UpdatePatientVisibilityRequest = {
  /** Patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
};
export type AdminPermissionRoleGrant = {
  /** Whether this role's cell can be overridden by the organization; some configurable permissions restrict which role cells are editable */
  configurable?: boolean;
  /** Whether the base RBAC catalog grants this permission */
  default_enabled: boolean;
  /** Role description */
  description: string;
  /** Whether the permission is enabled */
  enabled: boolean;
  /** Role display label */
  label: string;
  /** Whether the org has overridden the catalog default */
  overridden: boolean;
  /** Role key */
  role: string;
};
export type AdminPermissionMatrixItem = {
  /** Whether this permission can be overridden by organization */
  configurable?: boolean;
  /** Permission description */
  description: string;
  /** Permission display label */
  label: string;
  /** Permission key */
  permission: string;
  /** Effective role grants for this permission */
  roles?: AdminPermissionRoleGrant[];
};
export type AdminPermissionsMatrixResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Role by permission matrix */
  permissions?: AdminPermissionMatrixItem[];
  /** Whether the operation was successful */
  success: boolean;
};
export type AdminUpdatePermissionsMatrixRequest = {
  /** Permission key to role key to enabled state */
  permissions: {
    [key: string]: {
      [key: string]: boolean;
    };
  };
};
export type AdminProviderUserInfo = {
  email?: string | null;
  name?: string | null;
  phone?: string | null;
  profile_picture?: string | null;
};
export type AdminProviderUserMetrics = {
  notes_created?: number | null;
};
export type AdminProviderResponse = {
  created_at?: string | null;
  email?: string | null;
  email_verified?: boolean | null;
  last_login_time?: string | null;
  name?: string | null;
  note_count?: number | null;
  organization_id?: string | null;
  payment_status?: string | null;
  provider_id: string;
  /** Deprecated; always null. Use roles. */
  role?: string | null;
  /** Membership roles in the organization */
  roles?: string[];
  /** Membership status (active or inactive) */
  status?: string | null;
  user_info?: AdminProviderUserInfo | null;
  user_metrics?: AdminProviderUserMetrics | null;
};
export type ListResponseAdminProviderResponse = {
  items: AdminProviderResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AdminRefundResponse = {
  /** Amount refunded by this action in cents */
  amount_refunded?: number | null;
  /** Charge that was refunded */
  charge_id?: string | null;
  /** Human-readable message about the operation */
  message: string;
  /** Stripe refund ID */
  refund_id?: string | null;
  /** Amount still refundable on the charge in cents */
  remaining_refundable?: number | null;
  /** Stripe refund status */
  status?: string | null;
  /** Whether the refund succeeded */
  success: boolean;
};
export type AdminRefundRequest = {
  /** Amount to refund in cents. Omit to refund the full remaining amount. Clamped server-side to what is actually still refundable */
  amount?: number | null;
  /** Stripe charge to refund, from the invoice's charge_id */
  charge_id: string;
  /** Free-text explanation. Stripe rejects reasons outside its enum, so this is stored as refund metadata and in our events */
  note: string;
  /** Stripe's refund reason category */
  reason?: "duplicate" | "fraudulent" | "requested_by_customer";
};
export type SubscriptionDashboardUrlResponse = {
  /** Stripe dashboard URL for viewing the subscription */
  dashboard_url: string;
  /** Organization ID */
  organization_id: string;
  /** Stripe subscription ID */
  subscription_id: string;
};
export type SyncSubscriptionResponse = {
  /** Billing admin user ID */
  billing_admin_id?: string | null;
  /** Number of billable members */
  member_count?: number | null;
  /** Human-readable message about the sync */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Updated subscription quantity */
  subscription_quantity?: number | null;
  /** Whether the sync was successful */
  success: boolean;
  /** Whether a webhook was triggered */
  webhook_triggered?: boolean;
};
export type AdminTemplateResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Whether the template is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
  /** Template ID */
  template_id: string;
};
export type AdminTemplateListResponse = {
  /** List of templates */
  templates?: AdminTemplateResponse[];
  /** Total number of templates */
  total_count?: number;
};
export type AdminTemplateResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Whether the template is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
  /** Template ID */
  template_id: string;
};
export type AdminTemplateCreateRequest = {
  /** Display name for the template */
  display_name?: string | null;
  /** Template ID to add */
  template_id: string;
};
export type AdminTemplateUpdateRequest = {
  /** New display name for the template */
  display_name: string;
};
export type RoleDefinition = {
  /** Human-readable description of what the role can do */
  description?: string;
  /** Whether this role has admin-level permissions */
  is_admin_equivalent: boolean;
  /** Whether this role counts for billing */
  is_billable: boolean;
  /** Whether this is a legacy role (for backward compatibility) */
  is_legacy: boolean;
  /** Whether this role has member-level permissions */
  is_member_equivalent: boolean;
  /** Role identifier */
  role: string;
};
export type AvailableRolesResponse = {
  /** List of roles that count for billing */
  billable_roles: string[];
  /** List of current (non-legacy) role identifiers */
  current_roles: string[];
  /** List of legacy role identifiers */
  legacy_roles: string[];
  /** List of all available roles */
  roles: RoleDefinition[];
};
export type ProviderOrganizationResponse = {
  /** URL to Stripe billing portal for self-service */
  billing_portal_url?: string | null;
  /** ISO timestamp of creation */
  created_at?: string | null;
  /** Total inactive member count */
  inactive_member_count?: number;
  /** Total active member count */
  member_count?: number;
  /** Organization name */
  name: string;
  /** Number of available seats */
  seat_count?: number | null;
  /** Subscription status (active/trial/expired) */
  subscription_status?: string | null;
};
export type UpdateOrganizationResponse = {
  /** Organization name */
  name: string;
};
export type UpdateOrganizationRequest = {
  /** New organization name (patient-facing) */
  name: string;
};
export type DataSecurityRequestResponse = {
  /** ISO 8601 timestamp */
  created_at: string;
  /** User-friendly message */
  message: string;
  /** UUID of the request */
  request_id: string;
  /** Request status (processing) */
  status: string;
};
export type BaaRequest = {
  /** Contact email */
  email: string;
  /** Covered entity / practice name */
  entity_name: string;
  /** Contact name */
  name: string;
};
export type MemberBundleResponse = {
  /** Assignment UUID for management operations */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle display name */
  bundle_name?: string | null;
  /** 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** When bundle became active */
  effective_from?: string | null;
  /** When bundle ends */
  effective_to?: string | null;
  /** Assignment status */
  status: string;
};
export type AdminBundleActionResponse = {
  /** Full assignment details */
  assignment?: MemberBundleResponse | null;
  /** Assignment ID */
  assignment_id?: string | null;
  /** Result message */
  message: string;
  /** Whether action succeeded */
  success: boolean;
};
export type AdminAddBundleRequest = {
  /** Bundle UUID to add */
  bundle_id: string;
};
export type CoiAddressRequest = {
  /** City */
  city: string;
  /** Country code */
  country?: string;
  /** Street address line 1 */
  line1: string;
  /** Street address line 2 */
  line2?: string | null;
  /** State */
  state: string;
  /** ZIP code */
  zip: string;
};
export type CoiRequest = {
  /** Business address */
  address: CoiAddressRequest;
  /** Business/organization name */
  business_name: string;
};
export type DataRetentionRequest = {
  /** Days to retain unsigned notes. null = no auto-delete. Common values: 30, 60, 90, 180, 365 */
  unsigned_notes_retention_days?: number | null;
};
export type ProviderFormResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Form ID */
  form_id: string;
};
export type ProviderFormListResponse = {
  /** List of forms */
  forms?: ProviderFormResponse[];
  /** Total number of forms */
  total_count?: number;
};
export type ProviderFormResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Form ID */
  form_id: string;
};
export type ProviderFormCreateRequest = {
  /** Form ID to add */
  form_id: string;
};
export type ProviderResourceActionResponse = {
  /** Response message */
  message?: string | null;
  /** ID of the affected resource */
  resource_id?: string | null;
  /** Whether the operation was successful */
  success: boolean;
};
export type ProviderInvitationResponse = {
  /** Bundle IDs to assign when invitation is accepted */
  bundle_ids?: string[];
  /** Whether the invitee will have can_prepare_prescriptions_on_behalf set on acceptance (GDN-1119) */
  can_prepare_prescriptions_on_behalf?: boolean | null;
  /** Invited email address */
  email: string;
  /** ISO timestamp when invitation expires */
  expires_at: string;
  /** Unique invitation identifier */
  invitation_id: string;
  /** Whether the invitee will have needs_cosign set on acceptance */
  needs_cosign?: boolean | null;
  /** True if this replaced a previous expired invitation */
  resent?: boolean;
  /** Deprecated: use `roles` instead. Populated with roles[0] for compat. */
  role: string;
  /** Roles to be assigned on acceptance */
  roles?: string[];
  /** ISO timestamp when invitation was sent */
  sent_at: string;
  /** Invitation status */
  status?: string;
};
export type ProviderInvitationListResponse = {
  /** List of pending invitations */
  invitations?: ProviderInvitationResponse[];
  /** Total number of pending invitations */
  total_count?: number;
};
export type ProviderInvitationResponse2 = {
  /** Bundle IDs to assign when invitation is accepted */
  bundle_ids?: string[];
  /** Whether the invitee will have can_prepare_prescriptions_on_behalf set on acceptance (GDN-1119) */
  can_prepare_prescriptions_on_behalf?: boolean | null;
  /** Invited email address */
  email: string;
  /** ISO timestamp when invitation expires */
  expires_at: string;
  /** Unique invitation identifier */
  invitation_id: string;
  /** Whether the invitee will have needs_cosign set on acceptance */
  needs_cosign?: boolean | null;
  /** True if this replaced a previous expired invitation */
  resent?: boolean;
  /** Deprecated: use `roles` instead. Populated with roles[0] for compat. */
  role: string;
  /** Roles to be assigned on acceptance */
  roles?: string[];
  /** ISO timestamp when invitation was sent */
  sent_at: string;
  /** Invitation status */
  status?: string;
};
export type ProviderInvitationRequest = {
  /** Bundle IDs to assign when invitation is accepted */
  bundle_ids?: string[];
  /** Set the per-member can_prepare_prescriptions_on_behalf flag at acceptance (GDN-1119). Only valid when `operations_support` is in roles. */
  can_prepare_prescriptions_on_behalf?: boolean | null;
  /** Email address to invite */
  email: string;
  /** Set the per-member needs_cosign flag at acceptance. Only valid when `clinician` or `clinical_staff` is in roles. */
  needs_cosign?: boolean | null;
  /** Deprecated: use `roles` instead. Will be removed after FE migrates. */
  role?: string | null;
  /** Roles to assign on acceptance. At least one required. */
  roles?: string[] | null;
};
export type ProviderInvitationAcceptResponse = {
  /** Human-readable result message */
  message: string;
  /** Organization ID if successful */
  organization_id?: string | null;
  /** Roles assigned to user */
  roles?: string[];
  /** Whether acceptance succeeded */
  success: boolean;
};
export type ProviderInvitationAcceptRequest = {
  /** Invitation token from email */
  token: string;
};
export type ProviderInvitationValidationResponse = {
  /** Whether the user can accept (false if in multi-member org) */
  can_accept?: boolean | null;
  /** Error message if invalid */
  error?: string | null;
  /** When the invitation expires */
  expires_at?: string | null;
  /** Display name of the user who sent the invitation */
  invited_by_name?: string | null;
  /** Email address the invitation was sent to */
  invited_email?: string | null;
  /** Display name of the inviting organization */
  organization_name?: string | null;
  /** Role to be assigned when accepted */
  role?: string | null;
  /** Invitation status (pending/accepted/expired/cancelled) */
  status?: string | null;
  /** Whether the invitation is valid */
  valid: boolean;
};
export type ProviderMemberActionResponse = {
  /** Human-readable result message */
  message: string;
  /** Whether the action succeeded */
  success: boolean;
  /** Affected user ID */
  user_id?: string | null;
};
export type ProviderUpdateInvitationRequest = {
  /** New bundle IDs to assign when invitation is accepted */
  bundle_ids?: string[] | null;
  /** Update the per-member can_prepare_prescriptions_on_behalf flag (GDN-1119). Only valid when the resulting role set includes operations_support. */
  can_prepare_prescriptions_on_behalf?: boolean | null;
  /** Update the per-member needs_cosign flag for acceptance. Only valid when the resulting role set includes clinician. */
  needs_cosign?: boolean | null;
  /** Deprecated: use `roles` instead. */
  role?: string | null;
  /** New roles to assign on acceptance */
  roles?: string[] | null;
};
export type ProviderLicenseType =
  | "MD"
  | "DO"
  | "PhD"
  | "PsyD"
  | "LCSW"
  | "LMSW"
  | "LISW"
  | "LICSW"
  | "LCSW-C"
  | "LMFT"
  | "LPC"
  | "LCPC"
  | "LPCC"
  | "LMHC"
  | "LCMHC"
  | "NP"
  | "PMHNP"
  | "APRN"
  | "CNS"
  | "PA"
  | "RN"
  | "LADC"
  | "LCADC"
  | "CADC"
  | "BCBA"
  | "PSYCH_ASSOC"
  | "PASTORAL"
  | "OTHER";
export type MemberPayerBillingOverride = {
  /** Member whose NPI renders claims for this payer (null = self) */
  bill_under_user_id?: string | null;
  /** Payer this rule applies to */
  payer_uuid: string;
};
export type MemberBillingInfo = {
  /** Accept insurance payment as full */
  accept_insurance_payment_as_full?: string | null;
  /** Submit claims with this member as rendering provider (all payers) */
  bill_under_user_id?: string | null;
  /** Override org default billing entity for claims */
  billing_entity_id?: string | null;
  /** Billing NPI (if different) */
  billing_npi_number?: string | null;
  /** City */
  city?: string | null;
  /** Name used in communications */
  communications_name?: string | null;
  /** Facility address line 1 */
  facility_address?: string | null;
  /** Facility address line 2 */
  facility_address2?: string | null;
  /** Fax number */
  fax_number?: string | null;
  /** First name for billing */
  first_name?: string | null;
  /** Last name for billing */
  last_name?: string | null;
  /** License number */
  license_number?: string | null;
  /** State of licensure */
  license_state?: string | null;
  /** Provider license type (MD, DO, LCSW, etc.) */
  license_type?: ProviderLicenseType | null;
  /** Provider NPI number */
  npi_number?: string | null;
  /** Per-payer bill-under rules; a rule wins over bill_under_user_id */
  payer_billing_overrides?: MemberPayerBillingOverride[];
  /** Phone number */
  phone?: string | null;
  /** Place of service code */
  place_of_service?: string | null;
  /** Override org default service facility for claims */
  service_facility_id?: string | null;
  /** Name used for signing */
  signing_name?: string | null;
  /** State */
  state?: string | null;
  /** Tax ID (EIN or SSN) */
  tax_id?: string | null;
  /** Tax ID type (EIN or SSN) */
  tax_id_type?: string | null;
  /** Rendering provider taxonomy code for claims */
  taxonomy_code?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type MemberBundleResponse2 = {
  /** Assignment UUID for management operations */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle display name */
  bundle_name?: string | null;
  /** 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** When bundle became active */
  effective_from?: string | null;
  /** When bundle ends */
  effective_to?: string | null;
  /** Assignment status */
  status: string;
};
export type ProviderOrganizationMemberResponse = {
  /** Provider billing information */
  billing_info?: MemberBillingInfo | null;
  /** Bundle assignments for this member (org-level + user-specific) */
  bundles?: MemberBundleResponse2[];
  /** Whether this member may prepare prescriptions on behalf of a prescriber (GDN-1119). Effective value: the per-person capability AND the operations_support role. */
  can_prepare_prescriptions_on_behalf?: boolean;
  /** ISO timestamp when user was deactivated */
  deactivated_at?: string | null;
  /** The member's DoseSpot clinician ID, if connected */
  dosespot_clinician_id?: string | null;
  /** Whether this member is registered as a DoseSpot clinician */
  dosespot_connected?: boolean;
  /** User email */
  email?: string | null;
  /** Historical (record-only) member: exists only so records can attribute to this person; permanently inactive, cannot be reactivated, and cannot log in */
  is_historical?: boolean;
  /** User mobile phone number (E.164 format) */
  mobile_phone_num?: string | null;
  /** User name */
  name?: string | null;
  /** List of roles in organization */
  roles?: string[];
  /** Membership status: 'active' or 'inactive' */
  status?: string;
  /** User ID */
  user_id: string;
};
export type ProviderMemberListResponse = {
  /** List of organization members */
  members?: ProviderOrganizationMemberResponse[];
  /** Total number of members */
  total_count?: number;
};
export type ProviderLicenseType2 =
  | "MD"
  | "DO"
  | "PhD"
  | "PsyD"
  | "LCSW"
  | "LMSW"
  | "LISW"
  | "LICSW"
  | "LCSW-C"
  | "LMFT"
  | "LPC"
  | "LCPC"
  | "LPCC"
  | "LMHC"
  | "LCMHC"
  | "NP"
  | "PMHNP"
  | "APRN"
  | "CNS"
  | "PA"
  | "RN"
  | "LADC"
  | "LCADC"
  | "CADC"
  | "BCBA"
  | "PSYCH_ASSOC"
  | "PASTORAL"
  | "OTHER";
export type MemberPayerBillingOverride2 = {
  /** Member whose NPI renders claims for this payer (null = self) */
  bill_under_user_id?: string | null;
  /** Payer this rule applies to */
  payer_uuid: string;
};
export type UpdateMemberBillingInfoRequest = {
  /** Accept insurance payment as full */
  accept_insurance_payment_as_full?: string | null;
  /** Submit claims with this member as rendering provider (all payers) */
  bill_under_user_id?: string | null;
  /** Override org default billing entity for claims */
  billing_entity_id?: string | null;
  /** City */
  city?: string | null;
  /** Name used in communications */
  communications_name?: string | null;
  /** Facility address line 1 */
  facility_address?: string | null;
  /** Facility address line 2 */
  facility_address2?: string | null;
  /** Fax number */
  fax_number?: string | null;
  /** First name for billing */
  first_name?: string | null;
  /** Last name for billing */
  last_name?: string | null;
  /** License number */
  license_number?: string | null;
  /** State of licensure */
  license_state?: string | null;
  /** Provider license type (MD, DO, LCSW, etc.) */
  license_type?: ProviderLicenseType2 | null;
  /** Provider NPI number */
  npi_number?: string | null;
  /** Per-payer bill-under rules; a rule wins over bill_under_user_id */
  payer_billing_overrides?: MemberPayerBillingOverride2[] | null;
  /** Phone number */
  phone?: string | null;
  /** Place of service code */
  place_of_service?: string | null;
  /** Override org default service facility for claims */
  service_facility_id?: string | null;
  /** Name used for signing */
  signing_name?: string | null;
  /** State */
  state?: string | null;
  /** Tax ID (EIN or SSN) */
  tax_id?: string | null;
  /** Tax ID type (EIN or SSN) */
  tax_id_type?: string | null;
  /** Rendering provider taxonomy code for claims */
  taxonomy_code?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type ProviderLicenseType3 =
  | "MD"
  | "DO"
  | "PhD"
  | "PsyD"
  | "LCSW"
  | "LMSW"
  | "LISW"
  | "LICSW"
  | "LCSW-C"
  | "LMFT"
  | "LPC"
  | "LCPC"
  | "LPCC"
  | "LMHC"
  | "LCMHC"
  | "NP"
  | "PMHNP"
  | "APRN"
  | "CNS"
  | "PA"
  | "RN"
  | "LADC"
  | "LCADC"
  | "CADC"
  | "BCBA"
  | "PSYCH_ASSOC"
  | "PASTORAL"
  | "OTHER";
export type MemberPayerBillingOverride3 = {
  /** Member whose NPI renders claims for this payer (null = self) */
  bill_under_user_id?: string | null;
  /** Payer this rule applies to */
  payer_uuid: string;
};
export type MemberBillingInfo2 = {
  /** Accept insurance payment as full */
  accept_insurance_payment_as_full?: string | null;
  /** Submit claims with this member as rendering provider (all payers) */
  bill_under_user_id?: string | null;
  /** Override org default billing entity for claims */
  billing_entity_id?: string | null;
  /** Billing NPI (if different) */
  billing_npi_number?: string | null;
  /** City */
  city?: string | null;
  /** Name used in communications */
  communications_name?: string | null;
  /** Facility address line 1 */
  facility_address?: string | null;
  /** Facility address line 2 */
  facility_address2?: string | null;
  /** Fax number */
  fax_number?: string | null;
  /** First name for billing */
  first_name?: string | null;
  /** Last name for billing */
  last_name?: string | null;
  /** License number */
  license_number?: string | null;
  /** State of licensure */
  license_state?: string | null;
  /** Provider license type (MD, DO, LCSW, etc.) */
  license_type?: ProviderLicenseType3 | null;
  /** Provider NPI number */
  npi_number?: string | null;
  /** Per-payer bill-under rules; a rule wins over bill_under_user_id */
  payer_billing_overrides?: MemberPayerBillingOverride3[];
  /** Phone number */
  phone?: string | null;
  /** Place of service code */
  place_of_service?: string | null;
  /** Override org default service facility for claims */
  service_facility_id?: string | null;
  /** Name used for signing */
  signing_name?: string | null;
  /** State */
  state?: string | null;
  /** Tax ID (EIN or SSN) */
  tax_id?: string | null;
  /** Tax ID type (EIN or SSN) */
  tax_id_type?: string | null;
  /** Rendering provider taxonomy code for claims */
  taxonomy_code?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type MemberBundleResponse3 = {
  /** Assignment UUID for management operations */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle display name */
  bundle_name?: string | null;
  /** 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** When bundle became active */
  effective_from?: string | null;
  /** When bundle ends */
  effective_to?: string | null;
  /** Assignment status */
  status: string;
};
export type MemberDetailResponse = {
  /** Provider billing information */
  billing_info?: MemberBillingInfo2 | null;
  /** Bundle assignments for this member (org-level + user-specific) */
  bundles?: MemberBundleResponse3[];
  /** ISO timestamp when user was deactivated */
  deactivated_at?: string | null;
  /** User email */
  email?: string | null;
  /** First name */
  first_name?: string | null;
  /** Historical (record-only) member: exists only so records can attribute to this person; permanently inactive, cannot be reactivated, and cannot log in */
  is_historical?: boolean;
  /** Last name */
  last_name?: string | null;
  /** User mobile phone number (E.164 format) */
  mobile_phone_num?: string | null;
  /** User name */
  name?: string | null;
  /** List of roles in organization */
  roles?: string[];
  /** Membership status: 'active' or 'inactive' */
  status?: string;
  /** User ID */
  user_id: string;
};
export type UpdateMemberProfileRequest = {
  /** Email address */
  email?: string | null;
  /** First name */
  first_name?: string | null;
  /** Last name */
  last_name?: string | null;
  /** Mobile phone number (E.164 format, e.g., +15551234567) */
  mobile_phone_num?: string | null;
};
export type ProviderUpdateRolesRequest = {
  /** New complete list of roles for the user */
  roles: string[];
};
export type ProviderPatientVisibilityResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Current patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
  /** Whether the operation was successful */
  success: boolean;
};
export type ProviderUpdatePatientVisibilityRequest = {
  /** Patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
};
export type ProviderPermissionRoleGrant = {
  /** True if this role's cell can be overridden per-org; some configurable permissions restrict which role cells are editable */
  configurable?: boolean;
  /** Catalog default permission value for this role */
  default_enabled: boolean;
  /** Human-readable role description */
  description: string;
  /** Effective permission value for this role */
  enabled: boolean;
  /** Human-readable role label */
  label: string;
  /** True when the effective value differs from the catalog default */
  overridden: boolean;
  /** Canonical role identifier */
  role: string;
};
export type ProviderPermissionMatrixItem = {
  /** True if this permission can be overridden per-org (editable in the matrix) */
  configurable?: boolean;
  /** Human-readable permission description */
  description: string;
  /** Human-readable permission label */
  label: string;
  /** Permission identifier */
  permission: string;
  /** Role grants for this permission */
  roles?: ProviderPermissionRoleGrant[];
};
export type ProviderPermissionsMatrixResponse = {
  /** Human-readable result message */
  message: string;
  /** Org-configurable permission matrix */
  permissions?: ProviderPermissionMatrixItem[];
  /** Whether the operation was successful */
  success: boolean;
};
export type ProviderUpdatePermissionsMatrixRequest = {
  /** Permission -> role -> enabled values for org-configurable permissions */
  permissions: {
    [key: string]: {
      [key: string]: boolean;
    };
  };
};
export type EffectiveOrganizationPreferences = {
  /** When true, the note editor nudges providers to fill all bracketed placeholders before signing (soft gate, client-enforced). */
  block_signing_until_placeholders_filled?: boolean;
  /** When true, finalizing a note signs it ('Sign Note'); when false, finalizing simply marks it completed ('Complete Note'). */
  note_signing_enabled?: boolean;
  /** When true, recording and note generation are only available from encounters tied to an existing scheduled appointment. */
  require_scheduled_appointment_for_note_creation?: boolean;
  /** When on, a note a clinical staff member generates on a clinician's appointment is authored by that clinician, with the staff member recorded as the documenter, and the clinician signs it once. When off, the staff member submits it and the clinician co-signs. */
  staff_drafts_attributed_to_provider?: boolean;
};
export type UpdateOrganizationPreferencesRequest = {
  /** Block (soft) note signing until bracketed placeholders are filled */
  block_signing_until_placeholders_filled?: boolean | null;
  /** Whether finalizing a note signs it ('Sign Note') instead of marking it completed ('Complete Note') */
  note_signing_enabled?: boolean | null;
  /** Require an existing scheduled appointment before providers can record or generate a note */
  require_scheduled_appointment_for_note_creation?: boolean | null;
  /** Whether a note a clinical staff member generates on a clinician's appointment is authored by that clinician and signed once, instead of being submitted by the staff member for co-signature */
  staff_drafts_attributed_to_provider?: boolean | null;
};
export type ProviderRoleInfo = {
  /** Role description */
  description: string;
  /** Human-readable role name */
  display_name: string;
  /** Whether this role has admin privileges */
  is_admin?: boolean;
  /** Whether this role is billable */
  is_billable?: boolean;
  /** Role identifier */
  role: string;
};
export type ProviderRoleListResponse = {
  /** List of available roles */
  roles?: ProviderRoleInfo[];
};
export type ProviderTemplateResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Template ID */
  template_id: string;
};
export type ProviderTemplateListResponse = {
  /** List of templates */
  templates?: ProviderTemplateResponse[];
  /** Total number of templates */
  total_count?: number;
};
export type ProviderTemplateResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Template ID */
  template_id: string;
};
export type ProviderTemplateCreateRequest = {
  /** Display name for the template */
  display_name?: string | null;
  /** Template ID to add */
  template_id: string;
};
export type ProviderTemplateUpdateRequest = {
  /** New display name for the template */
  display_name: string;
};
